<button
  mat-menu-item
  waiFilePicker
  (waiFilePickerFileChange)="onSubmit($event)"
  (waiFilePickerFileSizeError)="onFileSizeError($event)"
>
  <mat-icon>publish</mat-icon>
  <span *ngIf="withLabel">
    {{ 'INTL_UPDATE' | translate }}
  </span>
</button>
